import useTranslation from '../useTranslation';
import { format } from 'date-fns';
import { useState } from 'react';
import downloadFile from 'utils/downloadFile';
import generateKml from 'utils/generateKml';

import { ERROR_TYPE } from 'components/ExportDropdown/constants';

import useToast from 'hooks/useToast';

import { FILENAME_DATE_FORMAT, FILENAME_PREFIX, KML_EXTENSION, KML_MIME_TYPE } from './constants';
import type { UseExportKmlProps, UseExportKmlReturn } from './types';

const useExportKml = ({ selectedFlights }: UseExportKmlProps): UseExportKmlReturn => {
    const [isExporting, setIsExporting] = useState(false);
    const { broadcastToast } = useToast();
    const { EXPORT_ERROR } = useTranslation();

    const handleExportKml = async () => {
        try {
            setIsExporting(true);

            const filename = `${FILENAME_PREFIX}${format(new Date(), FILENAME_DATE_FORMAT)}${KML_EXTENSION}`;
            const kmlContent = generateKml(selectedFlights);

            downloadFile(kmlContent, filename, KML_MIME_TYPE);
        } catch {
            await broadcastToast({ text: EXPORT_ERROR, type: ERROR_TYPE });
        } finally {
            setIsExporting(false);
        }
    };

    return { handleExportKml, isExporting };
};

export default useExportKml;
